var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Wand = function Wand(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 16' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M0 8.421h2.5V7.58H0zm6.667-5.053H7.5V.842h-.833zm-4.809.062l1.325 1.338.59-.595-1.326-1.34zm9.634 0l-.59-.596-1.324 1.339.589.595zm2.198 10.975c-.471.478-1.295.478-1.768 0l-4.77-4.824 1.791-1.81 4.77 4.825c.488.493.488 1.294-.022 1.81zM6.76 5.563l1.594 1.613-1.79 1.81L4.97 7.373l1.79-1.811zM14.303 12L6.76 4.37 3.79 7.374l7.542 7.627a2.06 2.06 0 0 0 1.473.617c.557 0 1.08-.22 1.497-.641a2.123 2.123 0 0 0 0-2.976z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Wand;
//# sourceMappingURL=Wand.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Wand.js